import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {string} */
const initialState = null;

const reset = () => null;

/**
 *
 * @param {string} _
 * @param {import('modules/statistics/types').FetchInterventionCountFailureAction} action
 * @returns {string}
 */
const setError = (_, { payload }) => payload;

export default createReducer(initialState, {
  [types.FETCH_STATISTICS_INTERVENTION_COUNT_REQUEST]: reset,
  [types.FETCH_STATISTICS_INTERVENTION_COUNT_FAILURE]: setError,
});
